// 각 컬럼의 고정 너비 (하드코딩)
const COLUMN_WIDTHS = {
  checkbox: "40px",
  dragHandle: "40px",
  no: "60px",
  empNum: "80px",
  name: "80px",
  role: "60px",
  age: "70px",
  grade: "70px",
  experience: "80px",
  isHeadNurse: "80px",
  weeklyOff: "80px",
  fixedShift: "150px",
  weekendOff: "90px",
  preceptor: "100px",
  wantedMaxRequests: "100px",
  enableAide: "100px",
  enableNursePairPreference: "100px",
  joiningDate: "120px",
  resignationDate: "120px",
  tenure: "100px",
  memo: "150px",
  edit: "80px",
  delete: "60px",
};

export const headerList = [
  { label: "", width: COLUMN_WIDTHS.dragHandle },
  { label: "checkbox", width: COLUMN_WIDTHS.checkbox },
  { label: "No.", width: COLUMN_WIDTHS.no },
  { label: "사번", width: COLUMN_WIDTHS.empNum },
  { label: "이름", width: COLUMN_WIDTHS.name },
  { label: "직종", width: COLUMN_WIDTHS.role },
  { label: "직책", width: COLUMN_WIDTHS.role },
  { label: "나이(만)", width: COLUMN_WIDTHS.age },
  { label: "Grade", width: COLUMN_WIDTHS.grade },
  { label: "경력", width: COLUMN_WIDTHS.experience },
  { label: "관리자", width: COLUMN_WIDTHS.isHeadNurse },
  { label: "프리셉터", width: COLUMN_WIDTHS.preceptor },
  { label: "주휴", width: COLUMN_WIDTHS.weeklyOff },
  { label: "근무형태", width: COLUMN_WIDTHS.fixedShift },
  { label: "주말 휴무", width: COLUMN_WIDTHS.weekendOff },
  // { label: "원티드 요청 제한", width: COLUMN_WIDTHS.wantedMaxRequests },
  // { label: "원티드 AI기능 사용", width: COLUMN_WIDTHS.enableAide },
  // { label: "시크릿기능 사용", width: COLUMN_WIDTHS.enableNursePairPreference },
  { label: "입사일", width: COLUMN_WIDTHS.joiningDate },
  { label: "재직기간", width: COLUMN_WIDTHS.tenure },
  { label: "근무 종료일", width: COLUMN_WIDTHS.resignationDate },
  { label: "메모", width: COLUMN_WIDTHS.memo },
  { label: "수정", width: COLUMN_WIDTHS.edit },
];

export { COLUMN_WIDTHS };
